import React, { useEffect, useState } from 'react'
import ListGroup from '../../userPages/partials/ListGroup'
import UserHero from '../../userPages/partials/UserHero'
import { CiCirclePlus } from "react-icons/ci";
import { Link, useNavigate } from 'react-router-dom';
import { MdDeleteForever } from "react-icons/md";
import { FaFrownOpen } from "react-icons/fa";
import { CiEdit } from "react-icons/ci";
import toast from 'react-hot-toast';
import UserAccount from '../../userPages/partials/UserAccount';

export default function Offers () {
    let [data,setData] = useState([])
    let navigate = useNavigate()

 const updateAdmin=()=>{
    alert("Update Admin")
     navigate(`/admin/offerUpdate/${data._id}`)
 }

async function deleteData(_id) {
   if(window.confirm("Are You Sure to Delete that Item :")){
    let response = await fetch(`http://34.228.14.188:8000/api/offer/`+ _id,{
        method:"DELETE",
        headers:{
            "content-type" : "application/json"
        },
        body : JSON.stringify({...data})
    })
    response = await response.json()
    

    if(response.result ==="Done"){
        toast.success("Delete Successfully")
        setData(response)
    }
   }
}



async function getApiData() {
    let response = await fetch( "http://34.228.14.188:8000/api/offer" , {
           method :"GET",
           headers:{
            "content-type":"application/json",
              // "authorization":localStorage.getItem("token")
                  }
    })

    response = await response.json()
    if(response.result ==="Done"){
        setData(response.data)
    }    
}



useEffect(()=>{
    getApiData()
} ,[data?.length])
  return (
    <>
    <UserHero/>
       <div className="container">
         <UserAccount/>
                <div className="row my-3">
                 
                    <ListGroup/>
                  
                  <div className="col-md-8">
         <h1 className=' testimonials-h1 text-light text-center p-2' style={{background:"#"}}>User Offers Table <Link to="/admin/create-offers"> <CiCirclePlus className='float-end text-light' /> </Link></h1>
         <div className="table-responsive">
             {
                data.length?

                <table className='table table-bordered responsive'>
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Room Name</th>
                        <th>Pic</th>
                        <th>Discount Offer </th>
                        <th>Discount Offer2</th>
                        <th>Offer Valid Date</th>
                        <th>Room Description</th>
                        <th>Edit</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        data.map((item,index)=>{
                            return <tr key={index}>
                                <td>{item._id}</td>
                                <td>
                                <div style={{overflow:"auto", height:"80px" , width:"220px"}}>
                                    {item.name}
                                    </div>
                                    </td>
                                <td>
                                    {/* <Link to={`${item.pic}`}> */}
                                    <img src={`/${item.pic}`} alt="testimonila-table-img" height={50} width={50}  />
                                    {/* </Link> */}
                                </td>
                                <td >
                                    <div style={{overflow:"auto", height:"80px" , width:"200px"}}>
                                    {item.offerDiscount}

                                    </div>
                                </td>
                                <td >
                                    <div style={{overflow:"auto", height:"80px" , width:"200px"}}>
                                    {item.offerEating}

                                    </div>
                                </td>
                                <td>
                                    {new Date(item.validdate).toLocaleDateString("en-IN" )}
                                </td>
                                <td >
                                    <div style={{overflow:"auto", height:"80px" , width:"220px"}}>
                                    {item.description}
                                    </div>
                                </td>
                                <td>
                                 <button>
                                   <CiEdit  onClick={updateAdmin} className='testimonil-table-btn' style={{height:"30", width:"50",color:"blue" }} />
                                   </button>    
                                </td>
                                <td>
                               
                                <MdDeleteForever className='testimonil-table-btn' style={{height:"30", width:"50", }} onClick={() => deleteData(item._id)} />
                            
                                </td>

                            </tr>
                        })
                    }
                </tbody>
              </table>
              :
              <div className="not-testinomonil">
                <h3>Sorry! <FaFrownOpen />  User Offers Record Not Found!!</h3>
                
              </div>
             }
            
                  </div>
              </div>
              </div>
       </div>
    </>
  )
}
